import $586dX$lodash from "lodash";
import {reactive as $586dX$reactive} from "vue";



class $5da1effdcec45422$var$Foreground {
    constructor(){
        this.bindings = (0, $586dX$reactive)([]);
        this.layers = (0, $586dX$reactive)([]);
    }
    get focused() {
        return (0, $586dX$lodash).last(this.layers);
    }
    /**
   * Add a component to the foreground and give it focus
   * @param component
   * @param bindings
   */ add(component, bindings = [], attrs = {}) {
        this.layers.push({
            component: component,
            bindings: bindings,
            attrs: attrs
        });
        (0, $586dX$lodash).each(bindings, ({ event: event , callback: callback  })=>{
            this._bind({
                component: component,
                event: event,
                callback: callback
            });
        });
    }
    /**
   * Remove a component from the foreground (or any other sub layers)
   * @param component
   */ remove(component) {
        if (!(0, $586dX$lodash).find(this.layers, ({ component: c  })=>c === component)) return;
        (0, $586dX$lodash).remove(this.layers, ({ component: c  })=>c === component);
        this._unbind(component);
    }
    /**
   * Bring a component that is already in the list of sub layers to the foreground
   * @param component
   */ focus(component) {
        const layer = (0, $586dX$lodash).find(this.layers, ({ component: c  })=>c === component);
        (0, $586dX$lodash).remove(this.layers, (l)=>l === layer);
        this.layers.push(layer);
    }
    _bind({ component: component , event: event , callback: callback  }) {
        const handler = (e)=>this.focused && this.focused.component === component && callback(e);
        window.addEventListener(event, handler);
        this.bindings.push({
            event: event,
            component: component,
            handler: handler
        });
    }
    _unbind(component) {
        const bindings = (0, $586dX$lodash).filter(this.bindings, ({ component: c  })=>c === component);
        (0, $586dX$lodash).each(bindings, (binding)=>{
            window.removeEventListener(binding.event, binding.handler);
            (0, $586dX$lodash).remove(this.bindings, (b)=>b === binding);
        });
    }
}
var $5da1effdcec45422$export$2e2bcd8739ae039 = new $5da1effdcec45422$var$Foreground();




const $a0a7d726f8e0f182$var$mixin = {
    computed: {
        foregroundFocused () {
            return (0, $586dX$lodash).last((0, $5da1effdcec45422$export$2e2bcd8739ae039).layers);
        }
    }
};
var $a0a7d726f8e0f182$export$2e2bcd8739ae039 = $a0a7d726f8e0f182$var$mixin;




const $7bbdaf15ed6f9abb$var$mixin = {
    mixins: [
        (0, $a0a7d726f8e0f182$export$2e2bcd8739ae039)
    ],
    created () {
        this.foregroundBindings = [];
    },
    methods: {
        foregroundAdd (attrs = {}) {
            (0, $5da1effdcec45422$export$2e2bcd8739ae039).add(this, this.foregroundBindings, attrs);
        },
        foregroundRemove () {
            (0, $5da1effdcec45422$export$2e2bcd8739ae039).remove(this);
        },
        foregroundFocus () {
            (0, $5da1effdcec45422$export$2e2bcd8739ae039).focus(this);
        }
    }
};
var $7bbdaf15ed6f9abb$export$2e2bcd8739ae039 = $7bbdaf15ed6f9abb$var$mixin;




export {$5da1effdcec45422$export$2e2bcd8739ae039 as foreground, $7bbdaf15ed6f9abb$export$2e2bcd8739ae039 as mixin, $a0a7d726f8e0f182$export$2e2bcd8739ae039 as appMixin};
//# sourceMappingURL=module.js.map
